import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class DropdownButtonDropdown extends Component {
  constructor(props) {
    super(props);
    this.renderDropdown = this.renderDropdown.bind(this);
  }

  layerDivRef = React.createRef();

  componentDidUpdate() {
    this.renderDropdown();
  }

  componentDidMount() {
    // create an element to hold the dropdown
    this.dropdown = document.createElement('div');
    // the below styling is required, as otherwise if you scroll the 'body', the positioning of the dropdown will be off
    this.dropdown.style.position = 'fixed';
    this.dropdown.style.zIndex = 12; // needs to appear above other page content (and other page content should never need to be above z-index 12)
    this.dropdown.style.top = 0;
    // append it to the document body (so that dropdown will sit on top of all other elements)
    document.body.appendChild(this.dropdown);
    // now render the dropdown
    this.renderDropdown();

    //
    // TODO: this logic below should be moved out of this component and into the user of this component
    //

    // scroll in newworld leftsidebar on query builder page
    const leftSidebar = window.trevzSidebar;
    if (leftSidebar) {
      leftSidebar.addEventListener('scroll', this.renderDropdown);
    }

    // scroll in share modal leftsidebar
    const modalSidebar = window.trevzShareModalSidebar;
    if (modalSidebar) {
      modalSidebar.addEventListener('scroll', this.renderDropdown);
    }
  }

  componentWillUnmount() {
    // remove React component from DOM
    ReactDOM.unmountComponentAtNode(this.dropdown);
    // remove div from DOM
    document.body.removeChild(this.dropdown);
    const leftSidebar = window.trevzSidebar;
    if (leftSidebar) {
      leftSidebar.removeEventListener('scroll', this.renderDropdown);
    }
    const modalSidebar = window.trevzShareModalSidebar;
    if (modalSidebar) {
      modalSidebar.removeEventListener('scroll', this.renderDropdown);
    }
  }

  renderDropdown() {
    // calculate the position of the dropdown (relative to the empty div created in render())
    const { contentWidth } = this.props;
    const pos = this.layerDivRef.current.getBoundingClientRect();
    const screenWidth = window.innerWidth;
    const hasScreenOverflow =
      contentWidth && screenWidth - pos.left < contentWidth;
    const style = {
      position: 'absolute',
      top: `${pos.top - 10}px`,
      left: hasScreenOverflow
        ? `${pos.left - contentWidth}px`
        : `${pos.left + 15}px`,
    };
    // render the positioned dropdown inside the body div we created in componentDidMount
    ReactDOM.render(
      <div style={style}>{this.props.contentBuilder()}</div>,
      this.dropdown,
    );
  }

  render() {
    // we are just rendering this empty div in order to know position of where to put the dropdown
    return <div ref={this.layerDivRef} />;
  }
}

export default DropdownButtonDropdown;
